const boxDecorationBreak = {
    name: "box-decoration-break",
    path: "/box-decoration-break",
    title: "box-decoration-break",
    description: "Utilities for controlling how element fragments should be rendered across multiple lines, columns, or pages.",
    value: {
        "box-decoration-break":{
            "box-decoration-slice": "slice",
            "box-decoration-clone": "clone",
        }
    },
    exampleData:     [
        {
      "title": "",
      "description": "",
      "example": {
        "element": "",
        "src": "",
        "className": "",
        "code": `<span class="box-decoration-slice bg-linear-to-r from-indigo-600 to-pink-500 px-2 text-white ...">
  Hello<br />World
</span>
<span class="box-decoration-clone bg-linear-to-r from-indigo-600 to-pink-500 px-2 text-white ...">
  Hello<br />World
</span>`
      }
    }
    ],
    htmlData: [
        {
            data: `
            <div>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">box-decoration-slice</code> and <code class="text-color-gray-800 dark:text-color-white font-semibold">box-decoration-clone</code> utilities to control whether properties like background, border, border-image, box-shadow, clip-path, margin, and padding should be rendered as if the element were one continuous fragment, or distinct blocks:
            </p>
            <div class="my-8 grid grid-columns-1 gap-10 px-10 font-bold sm:grid-columns-2">
            <div class="flex flex-col">
                <p class="mb-3 text-xs font-medium text-color-gray-500 dark:text-color-gray-400">box-decoration-slice</p>
                <div class="font-sans text-5xl font-extrabold tracking-tight">
                <span class="bg-gradient-[linear-gradient(90deg,_color-indigo-500,_color-purple-500,_color-pink-500)] box-decoration-slice px-2 text-color-white">Hello<br />World</span>
                </div>
            </div>
            <div class="flex flex-col">
                <p class="mb-3 text-xs font-medium text-color-gray-500 dark:text-color-gray-400">box-decoration-clone</p>
                <div class="font-sans text-5xl font-extrabold tracking-tight">
                <span class="bg-gradient-[linear-gradient(90deg,_color-indigo-500,_color-purple-500,_color-pink-500)] box-decoration-clone px-2 text-color-white">Hello<br />World</span>
                </div>
            </div>
            </div>
        </div>
            `
        }
    ]
};

export default boxDecorationBreak;


<div className="sr-only">
    <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
        Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">box-decoration-slice</code> and <code class="text-color-gray-800 dark:text-color-white font-semibold">box-decoration-clone</code> utilities to control whether properties like background, border, border-image, box-shadow, clip-path, margin, and padding should be rendered as if the element were one continuous fragment, or distinct blocks:
    </p>
    <div class="my-8 grid grid-columns-1 gap-10 px-10 font-bold sm:grid-columns-2">
    <div class="flex flex-col">
        <p class="mb-3 text-xs font-medium text-color-gray-500 dark:text-color-gray-400">box-decoration-slice</p>
        <div class="font-sans text-5xl font-extrabold tracking-tight">
        <span class="bg-gradient-[linear-gradient(90deg,_color-indigo-500,_color-purple-500,_color-pink-500)] leading-6 box-decoration-slice px-2 text-color-white">Hello<br />World</span>
        </div>
    </div>
    <div class="flex flex-col">
        <p class="mb-3 text-xs font-medium text-color-gray-500 dark:text-color-gray-400">box-decoration-clone</p>
        <div class="font-sans text-5xl font-extrabold tracking-tight">
        <span class="bg-gradient-[linear-gradient(90deg,_color-indigo-500,_color-purple-500,_color-pink-500)] box-decoration-clone px-2 text-color-white">Hello<br />World</span>
        </div>
    </div>
    </div>
</div>